// client/src/components/utils/attachmentUtils.js
import axios from 'axios';

// Deve restare allineato a server/middleware/upload.middleware.js
export const MAX_ATTACHMENT_SIZE = 20 * 1024 * 1024; // 20 MB

export const ALLOWED_ATTACHMENT_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/tiff',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
];

export const ACCEPT_ATTR = '.pdf,.png,.jpg,.jpeg,.tif,.tiff,.doc,.docx,.xls,.xlsx';

/**
 * Valida un File lato client prima dell'upload.
 * @returns {string|null} chiave i18n dell'errore, oppure null se valido
 */
export const validateAttachmentFile = (file) => {
  if (!file) return null;
  if (file.size > MAX_ATTACHMENT_SIZE) return 'vatCredit.attachments.fileTooLarge';
  if (file.type && !ALLOWED_ATTACHMENT_TYPES.includes(file.type)) {
    return 'vatCredit.attachments.unsupportedType';
  }
  return null;
};

export const formatFileSize = (bytes) => {
  if (!bytes && bytes !== 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/**
 * Scarica un allegato di una richiesta Crediti IVA autenticandosi via axios
 * (l'header Authorization è già impostato globalmente da AuthContext) e
 * forza il salvataggio lato browser.
 */
export const downloadVatCreditAttachment = async (requestId, attachment) => {
  const res = await axios.get(
    `/api/vat-credit-requests/${requestId}/attachments/${attachment.id}`,
    { responseType: 'blob' }
  );

  const blobUrl = window.URL.createObjectURL(new Blob([res.data], { type: attachment.mimeType }));
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = attachment.originalName || 'allegato';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
};
